module.exports = __webpack_public_path__ + "static/media/celular-15-dic.a4078ecf.svg";